// extracted by mini-css-extract-plugin
export var screenLg = "992px";
export var screenXl = "1200px";
export var screenMd = "768px";
export var screenSm = "576px";
export var screenXlMax = "1199px";
export var screenLgMax = "991px";
export var screenMdMax = "767px";
export var screenSmMax = "575px";
export var LatestContent = "LatestContent-module--LatestContent--3PuNX";
export var LatestContent__wrapper = "LatestContent-module--LatestContent__wrapper--2SVn6";
export var LatestContent__promoSlotContainer = "LatestContent-module--LatestContent__promoSlotContainer--1rYki";
export var LatestContent__heroSlot = "LatestContent-module--LatestContent__heroSlot--1W7JP";
export var LatestContent__heroSlot__imageContainer = "LatestContent-module--LatestContent__heroSlot__imageContainer--1UZ9s";
export var LatestContent__heroSlot__textWrap = "LatestContent-module--LatestContent__heroSlot__textWrap--20_PJ";
export var LatestContent__promoSlot = "LatestContent-module--LatestContent__promoSlot--1in8i";
export var LatestContent__promoSlot__textWrap = "LatestContent-module--LatestContent__promoSlot__textWrap--2jUCU";
export var LatestContent__promoSlot__imageContainer = "LatestContent-module--LatestContent__promoSlot__imageContainer--1VUAW";
export var LatestContent__promoSlot__header = "LatestContent-module--LatestContent__promoSlot__header--3pCYZ";
export var LatestContent__promoSlot__title = "LatestContent-module--LatestContent__promoSlot__title--1owdt";
export var LatestContent__promoSlot__cta = "LatestContent-module--LatestContent__promoSlot__cta--Nw6gy";
export var LatestContent__heroSlot__header = "LatestContent-module--LatestContent__heroSlot__header--2gvBJ";
export var LatestContent__heroSlot__title = "LatestContent-module--LatestContent__heroSlot__title--3dGoc";
export var LatestContent__maskBackground = "LatestContent-module--LatestContent__maskBackground--_GYex";